import { createSlice } from "@reduxjs/toolkit";

export const headerSlice = createSlice({
  name: "header",
  initialState: {
    selectedVendor: [],
    fetch: true,
  },
  reducers: {
    updateHeaderData: (state, data) => ({
        ...state,
        ...(state = data?.payload ? data.payload : data)
    })
  },
});

// export const {updateVendorDetails, updateVendorStatus, updateUserPermission, updateWorkflowSteps} = serviceSlice.actions
export const { updateHeaderData } = headerSlice.actions;
export default headerSlice.reducer;
